export const faAlignRight = {
  prefix: 'fpm',
  iconName: 'fa-align-right',
  icon: [
    24,
    24,
    [],
    'e001',
    'M18.4 12.32v9.32h1V3h-1v9.32m-9.8-3.6v1.96h8.48V6.76H8.6v1.96M4 15.92v1.96h13.08v-3.92H4v1.96',
  ],
};
